import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import EventCreationModal from "../../components/event-management/event-creation-modal";
import EventList from "../../components/event-management/event-list";
import { awsRum } from "../..";
import { RUMPage } from "../../enums/rum";

const EventManagementPage = () => {
  useEffect(() => {
    try {
      awsRum.recordPageView(RUMPage.EVENT_MGMT);
    } catch {
      // Swallow rum errors
    }
  }, []);

  return (
    <>
      <Grid container xs alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="h6" component="h1">
            Major Construction & Events
          </Typography>
        </Grid>
        <Grid item m={1}>
          <EventCreationModal />
        </Grid>
      </Grid>

      <EventList />
    </>
  );
};

export default EventManagementPage;
